import styled from 'styled-components';
var Main = styled.main.withConfig({
  displayName: "Bodystyles__Main",
  componentId: "sc-w7gw0l-0"
})(["flex:1;overflow:auto;"]);
var Body = styled.div.withConfig({
  displayName: "Bodystyles__Body",
  componentId: "sc-w7gw0l-1"
})(["width:100%;max-width:", ";margin:0 auto;padding:", ";"], function (props) {
  return props.isFullWidth ? '100%' : '872px';
}, function (props) {
  return props.isFullWidth ? 0 : "var(--dentsu-spacing-32) var(--dentsu-spacing-32) var(--dentsu-spacing-48)";
});
export var Styled = {
  Main: Main,
  Body: Body
};